import React, { Component } from "react";
import "../../style/common/headBar.scss";
import BMW from "../../image/BMW.SVG";
import AllowLeft from "../../icon/AllowLeft";
import logo from "../../image/tf-logo-blue.svg";
import Basket from "../../image/hd_cart.png";
import { routePage } from "../../utils/routePage";
import header from "../../image/headLogo.png";
import TeslaIcon from "../../icon/TeslaIcon";

class HeadBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      num: props.num,
      ad: JSON.parse(localStorage.getItem("ad")),
    };
    this.back = this.back.bind(this);
  }

  componentDidMount() {
    const num = localStorage.getItem("cartNum") || 0;
    this.setState({ num });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.num !== this.props.num) {
      this.setState({ num: this.props.num });
    }
  }

  back() {
    let { history, location } = this.props;
    let { ad } = this.state;
    if (location.pathname === "/success" || location.pathname === "/Success") {
      return (
        history &&
        history.push({
          pathname: "/",
          search: ad,
        })
      );
    }
    history.goBack();
  }

  render() {
    return (
      <React.Fragment>
        <div className="header-box">
          <div className="header-contain">
            <AllowLeft
            size={20}
            color="rgb(18, 25, 44)"
            onClick={this.back}
            className="allowLeft"
          />
           <TeslaIcon width={120} height={50} color="rgb(18, 25, 44)" />
            <div className="right"></div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default HeadBar;
